// Existing controls the model picked for a risk, out of the controls not yet linked to it.
export class CopilotRiskControlSuggestion {
  controlId: number;

  code: string;

  name: string;

  constructor() {
    this.controlId = 0;
    this.code = '';
    this.name = '';
  }
}

export class CopilotRiskControlSuggestions {
  controls: CopilotRiskControlSuggestion[];

  constructor() {
    this.controls = [];
  }
}
